import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { EbookMockup } from './EbookMockup';
export function IncludesSection() {
  const items = ['Guía digital completa de 14 días', 'Plan simple paso a paso', 'Hábitos diarios fáciles de aplicar', 'Enfoque práctico y claro'];
  return <section className="py-24 bg-[#EDE4D6]/50 backdrop-blur-[2px] overflow-hidden" data-id="element-124">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-125">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-126">
          {/* Left: Mockup */}
          <motion.div className="flex justify-center lg:justify-end" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-127">
            <div className="relative" data-id="element-128">
              <div className="absolute inset-0 bg-sage-50 rounded-full blur-3xl scale-150 -z-10" data-id="element-129"></div>
              <EbookMockup size="lg" data-id="element-130" />
            </div>
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-131">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-black mb-8" data-id="element-132">
              Esto es lo que recibirás
            </h2>

            <div className="space-y-6 mb-10" data-id="element-133">
              {items.map((item, index) => <motion.div key={index} className="flex items-start" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.2 + index * 0.1
            }} data-id="element-134">
                  <CheckCircleIcon className="w-6 h-6 text-emerald-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-lg text-black/80 font-semibold" data-id="element-136">
                    {item}
                  </span>
                </motion.div>)}
            </div>

            <CTAButton text="Acceder al ebook" variant="primary" href="#oferta" data-id="element-137" />
          </motion.div>
        </div>
      </div>
    </section>;
}